/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_2e17386d","_2e17386d",""]'><div :class='["","_2e17386d",""]'><div :class='["","_2e17386d",""]'>slot + wx:model来开展使用能力</div><div :class='["bg-white","_2e17386d",""]'><cube-collapse :switch-text="([])" :collapsed="collapsed" mpxModelEvent="input" @mpxModel='(e)=>__invoke(e, [["__model","collapsed", "__mpx_event__", ["value"], undefined]])' :class='["","_2e17386d",""]'><div :class='["","_2e17386d",""]'><div :class='["","_2e17386d",""]'>内容，第一行</div><div :class='["","_2e17386d",""]'>内容，第二行</div><div :class='["","_2e17386d",""]'>内容，第三行</div></div><div slot="top-switch" :class='["","_2e17386d",""]'>点我使用组件的展开、收起</div></cube-collapse><div :class='["","_2e17386d",""]'>-------</div><div @tap='(e)=>__invoke(e, [["collapsedHandler"]])' :class='["","_2e17386d",""]'>点我通过wx:model进行展开、收起</div><div :class='["","_2e17386d",""]'>collapsed: {{ collapsed }}</div></div></div></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"scoped":true,"mid":"_2e17386d"}'>
.bg-white
  margin-top: 6px
  background-color: #fff
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_2e17386d"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_2e17386d"}
  /** script content **/
  require("./slot-wx-model.mpx.js?isComponent&outputPath=components%2Fslot-wx-model2e17386d%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./slot-wx-model.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fslot-wx-model2e17386d%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_2e17386d"],
    ctorType: "component",
    outputPath: "components/slot-wx-model2e17386d/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-collapse':getComponent(require("../../../packages/mpx-cube-ui/src/components/collapse/index.mpx?isComponent&outputPath=components%2Findex5127b398%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>